import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { UnavailableType } from './unavailable-type.interface';
import { UnavailableTypeService } from './unavailable-type.service';

const service = new UnavailableTypeService();

export interface UnavailableTypeState {
   unavailability_types: Array<UnavailableType>;
}

const UnavailableTypeStore: Module<UnavailableTypeState, StoreState> = {
   namespaced: true,
   state: {
      unavailability_types: [],
   },
   getters: {},
   mutations: {
      setState(state, unavailability_types) {
         state.unavailability_types = unavailability_types;
      },
   },
   actions: {
      async get(context) {
         if (context.state.unavailability_types?.length) return;
         const UNAVAILABLE_TYPES = await service.get().then((response) => response?.data);
         context.commit('setState', UNAVAILABLE_TYPES);
      },
   },
};

export default UnavailableTypeStore;
